import { Alert } from '@packages/ui/base/alert/alert';
import { Button } from '@packages/ui/base/button/button';
import { Input } from '@packages/ui/base/input/input';
import { Label } from '@packages/ui/base/input/label';
import { ArrowLeftIcon, CheckCircleIcon } from '@phosphor-icons/react';

export interface NameAndSubmitStepProps {
  name: string;
  submitting: boolean;
  error: string | undefined;
  onNameChange: (newName: string) => void;
  onBack: () => void;
  onSubmit: () => void;
}

export const NameAndSubmitStep = ({
  name,
  submitting,
  error,
  onNameChange,
  onBack,
  onSubmit,
}: NameAndSubmitStepProps) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <h1 className="mb-2 text-xl font-bold">Name your secret santa</h1>

      <div className="text-muted-foreground mb-6">
        Give it a fun name that participants will see when drawing.
      </div>

      <div className="mb-8 flex flex-col gap-2">
        <Label htmlFor="secret-santa-name">
          Name <span className="font-normal text-zinc-400">(optional)</span>
        </Label>
        <Input
          id="secret-santa-name"
          type="text"
          autoComplete="false"
          placeholder={`Secret Santa ${new Date().getFullYear()}`}
          value={name}
          onChange={e => onNameChange(e.target.value)}
          autoFocus
          disabled={submitting}
        />
      </div>

      {error && (
        <Alert variant="error" className="mb-4">
          {error}
        </Alert>
      )}

      <div className="flex items-center gap-2">
        <Button variant="secondary" onClick={onBack}>
          <ArrowLeftIcon className="mr-2 size-4" weight="bold" /> <span>Back</span>
        </Button>
        <Button className="grow" onClick={onSubmit} loading={submitting}>
          <span>Create</span> <CheckCircleIcon className="ml-2 size-4" weight="bold" />
        </Button>
      </div>
    </div>
  );
};
